routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']

export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
  .state('workplan', {
    abstract: false,
    url: '/workplan',
    views: {
      '': {
        template: require('../../../layout/layout.html')
      },
      'content': {
        template: require('../../../layout/content.html')
      },
      'aside': {
        template: require('../../../layout/aside.html'),
        controller: 'AsideCtrl'
      },
      'header': {
        template: require('../../../layout/header.html'),
        controller: 'HeaderCtrl'
      },
      'chatbox': {
        template: require('../chatbox/chatbox.html'),
        controller: 'ChatboxController',
        controllerAs: 'chatbox'
      },
      'footer': {
        template: require('../../../layout/footer.html')
      }
    },
    data: {displayName: 'Inicio'}
  })
  .state('fullscreen.workPlanGeneralInformation', {
    abstract: false,
    url: '/workplanGeneralInfo',
    template: require('./generalInformation/consultInformation/consultSummaryByArea.html'),
    controller: 'ConsultSummaryByAreaCtrl',
    controllerAs: 'summaryByAreaVm',
    data: {
      displayName: 'Inicio'
    }
  })
  .state('workplan.summary', {
    abstract: false,
    tag: 'summary',
    url: '/summary',
    template: require('./partials/review/summary/summary.html'),
    controller: 'summaryController',
    controllerAs: 'summaryVM',
    data: {
      displayName: 'Resumen'
    }
  })
  .state('fullscreen.workplanReviewApprobation', {
    abstract: false,
    url: '/workplanReviewApprobation',
    views: {
      '': {
        template: require('./start/index.html')
      },
      'principal@': {
        template: require('./start/approbation/workplanReviewPhaseApprobation.html'),
        controller: 'WorkPlanReviewPhaseApprobationCtrl',
        controllerAs: 'reviewPhaseApprobationVm'
      },
      'indicators@': {
        template: require('./indicatorsStart/indicatorsStart.html'),
        controller: 'IndicatorsStartCtrl',
        controllerAs: 'indicatorsVm'
      }
    },
    data: {
      displayName: 'Etapa aprobación'
    }
  })
  .state('fullscreen.workPlanPhaseExecution', {
    abstract: false,
    url: '/workPlanPhaseExecution',
    template: require('./start/execution/workplanPhaseExecution.html'),
    controller: 'WorkPlanPhaseExecutionCtrl',
    controllerAs: 'workPlanPhaseExecutionVm',
    data: {
      displayName: 'Etapa de ejecución'
    }
  })
  .state('fullscreen.workplanEvaluation1', {
    abstract: false,
    url: '/workplanEvaluation1',
    template: require('./start/evaluation/workplanEvaluation.html'),
    controller: 'WorkplanEvaluationCtrl',
    controllerAs: 'workplanEvaluationVM',
    data: {
      displayName: 'Etapa de evaluación'
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/workplan.route.js